import { render, staticRenderFns } from "./modal-collect-info.vue?vue&type=template&id=06bdf57f"
import script from "./modal-collect-info.vue?vue&type=script&lang=js"
export * from "./modal-collect-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports